"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("@angular-redux/store");
var argos_state_1 = require("./core/argos-state");
var AppModule = /** @class */ (function () {
    function AppModule(ngRedux) {
        ngRedux.configureStore(argos_state_1.rootReducer, argos_state_1.INITIAL_STATE);
    }
    AppModule.ctorParameters = function () { return [{ type: store_1.NgRedux }]; };
    return AppModule;
}());
exports.AppModule = AppModule;
//# sourceMappingURL=app.module.js.map


// WEBPACK FOOTER //
// app.module.js